import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Container, Button } from 'reactstrap';
import Loader from '../../components/Common/Loader';
import UpdateEntryStrategyForm from '../../components/Forms/UpdateEntryStrategyForm';
import { getEntryStrategyById } from '../../store/actions';

class EntryStrategyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      es: null,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const id = match.params.id;
    this.props.getEntryStrategyById({ token: this.state.user.token, id });
  }

  componentDidUpdate(prevProps) {
    const { loadingGetEntryStrategyById, entryStrategy, getEntryStrategyByIdError, history } = this.props;

    if (loadingGetEntryStrategyById === false && prevProps.loadingGetEntryStrategyById === true) {
      if (getEntryStrategyByIdError) {
        console.log('getEntryStrategyByIdError', getEntryStrategyByIdError);
        //history.push('/entry-strategies');
      } else if (entryStrategy) {
        this.setState({ es: entryStrategy });
      }
    }
  }

  goBack(event) {
    event.preventDefault();
    if (this.props.location.query) {
      this.props.history.push(this.props.location.query.origin_path);
    } else {
      this.props.history.push('/entry-strategies');
    }
  }

  render() {
    const { es } = this.state;
    if (!es) {
      return (
        <>
          <div className="loaderCenter">
            <Loader></Loader>
          </div>
        </>
      );
    }
    return (
      <>
        <div className="user-management">
          <Container fluid>
            <Button
              className="btn btn-primary waves-effect waves-light  usersButtons"
              onClick={(event) => this.goBack(event)}
            >
              <i className="fas fa-arrow-left"></i>
            </Button>
            <UpdateEntryStrategyForm entryStrategy={es} />
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { entryStrategy, getEntryStrategyByIdError, loadingGetEntryStrategyById, successGetEntryStrategies } =
    state.getEntryStrategyById;
  return {
    entryStrategy,
    getEntryStrategyByIdError,
    loadingGetEntryStrategyById,
    successGetEntryStrategies,
  };
};
export default withRouter(connect(mapStateToProps, { getEntryStrategyById })(withNamespaces()(EntryStrategyDetail)));
